import React, { useEffect, useState } from 'react';

import GeneralRiskWeightedValueTable from './weighted_value/GeneralRiskWeightedValueTable';

import { useToast } from 'Hooks/useToast';

export default function GeneralRiskWeightedValue(props) {
    const [risks, setRisks] = useState([]);
    const [opportunities, setOpportunities] = useState([]);
    const [summary, setSummary] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const toast = useToast();

    useEffect(() => {
        fetchGeneralRiskWeightedValues();
    }, []);

    const fetchGeneralRiskWeightedValues = () => {
        setIsLoading(true);
        axios
            .get(props.fetchUrl)
            .then(({ data }) => {
                setRisks([...data.risks]);
                setOpportunities([...data.opportunities]);
                setSummary({ ...data.summary });
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const updateRiskWeightedValue = (riskType, riskId, percentage) => {
        axios
            .put(props.updateUrl.replace('RISK_TYPE', riskType).replace('RISK_ID', riskId), { percentage })
            .then(() => {
                fetchGeneralRiskWeightedValues();
            })
            .catch((e) => {
                if (e.response && e.response.status === 422 && e.response.data.message) {
                    toast.error(e.response.data.message);
                }
            });
    };

    return (
        <GeneralRiskWeightedValueTable
            risks={risks}
            opportunities={opportunities}
            summary={summary}
            isLoading={isLoading}
            updateRiskWeightedValue={updateRiskWeightedValue}
        />
    );
}
